export function sendMessage(payload) {
  this.conversationSession.session.writeMessage(payload);
}

export function sendAudioMessage(payload) {
  this.conversationSession.session.createResourceEntry(payload.audioFile, 'wav', (error, result) => {
    if (!error) {
      if (result.status === 'UPLOADED') {
        this.conversationSession.session.writeResourceMessage(result.resource, undefined, (errorWriteMessage, success) => {
          if (errorWriteMessage) {
            throw errorWriteMessage;
          } else {
            console.log(success);
          }
        });
      } else {
        throw result;
      }
    } else {
      throw error;
    }
  });
}
